<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconConnectionIndicatorVeryLow_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <g clip-path="url(#IconConnectionIndicatorVeryLow_24__a)">
        <rect width="4" height="4" x="4" y="16" fill="currentColor" rx="1" />
        <rect
            width="4"
            height="9"
            x="10"
            y="11"
            fill="currentColor"
            opacity=".3"
            rx="1"
        />
        <rect
            width="4"
            height="16"
            x="16"
            y="4"
            fill="currentColor"
            opacity=".3"
            rx="1"
        />
    </g>
    <defs>
        <clipPath id="IconConnectionIndicatorVeryLow_24__a">
            <path fill="currentColor" d="M0 0h24v24H0z" />
        </clipPath>
    </defs>
</svg>
